// Tracks the live-data websockets that WE (the client) tore down on purpose --
// on component unmount, rapid back-button navigation, or the tab-hidden
// close-all. Closing a socket that is still `CONNECTING` makes the browser
// "fail the WebSocket connection", which emits a native `error` event that
// ReconnectingWebSocket re-dispatches to our `error` listeners. Those listeners
// must not surface that as a "Could not load live data" toast: nothing actually
// failed, we abandoned the socket ourselves. A genuine backend failure never
// marks the socket here (the owning component is still mounted, so the pool's
// `releaseSocket` is not called), so its toast still fires.
//
// A WeakSet keyed by the socket instance: pooled sockets are deleted from the
// pool when closed and never handed out again, so a marked instance is never
// reused and is free to be garbage-collected.
const intentionallyClosedSockets = new WeakSet<object>();

// Mark a socket as closed by client-initiated teardown. Call immediately before
// `socket.close()` at every deliberate close site.
export const markSocketIntentionallyClosed = (
    socket: object | null | undefined
): void => {
    if (socket) {
        intentionallyClosedSockets.add(socket);
    }
};

// True when this socket was closed by client-initiated teardown (see above).
// Read from a live-data socket's `error` listener before deciding to toast.
export const wasSocketIntentionallyClosed = (
    socket: object | null | undefined
): boolean => (socket ? intentionallyClosedSockets.has(socket) : false);
